/**
 * Ödeme marka görselleri — public/images/payments
 */
const base = process.env.PUBLIC_URL || '';

export const paymentLogoUrl = {
  visaMastercard: `${base}/images/payments/visa-mastercard.png?v=4`,
  revolut: `${base}/images/payments/revolut.svg`,
};

/** PaymentBrandLogos — Visa+Mastercard tek görsel */
export const paymentLogoSizeClass = {
  sm: {
    wrap: 'px-2.5 py-1.5',
    img: 'h-7 w-auto max-w-[min(100%,180px)] sm:h-8 sm:max-w-[200px]',
    extra: 'h-5 max-w-[64px]',
    label: 'text-xs',
  },
  default: {
    wrap: 'px-3 py-2',
    img: 'h-8 w-auto max-w-[min(100%,200px)] sm:h-9 sm:max-w-[220px]',
    extra: 'h-6 max-w-[72px]',
    label: 'text-sm',
  },
};
